import { PlanFamily, ProductFeature } from '@localstack/types';

import { capitalise } from './format';

/**
 * Extracts feature tuple from product string, which has a format of `name/variant/version`
 * @param product Product (feature) string to convert into tuple
 */
export const extractFeatureTuple = (product: string): [ProductFeature, string, string] => {
  const parts = product.split('/');

  if (parts.length !== 3) {
    throw new Error(`Invalid product string: ${product}`);
  }

  return [parts[0] as ProductFeature, parts[1] as string, parts[2] as string];
};

type FeaturePartitions = {
  featureTuples: [ProductFeature, string, string][];
  featureNames: ProductFeature[];
  featureVariants: string[];
};

export const extractFeaturePartitions = (features: string[]): FeaturePartitions => {
  const featureTuples = (features ?? []).map(extractFeatureTuple);
  const featureNames = featureTuples.map((f) => f[0]);
  const featureVariants = featureTuples.map((f) => f[1]);

  return {
    featureTuples,
    featureNames,
    featureVariants,
  };
};

const FamilyPlanMapping = {
  [PlanFamily.FREEMIUM_PLANS]: 'Hobby',
};
export const beautifyPlanName = (name: string): string => {
  const mappedName = name in FamilyPlanMapping ? FamilyPlanMapping[name as keyof typeof FamilyPlanMapping] : name;
  return mappedName
    .split('_')
    .map((part) => (part === 'aws' ? 'AWS' : capitalise(part)))
    .join(' ');
};
